import styled from "styled-components";

export const HeaderMain = styled.header`
  // box-shadow: 0 0px 10px 0px var(--choco);
  // margin-bottom: 10px;
  background-color: var(--white);

  .nav_bar_sec {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > .logo {
      > a {
        display: flex;
        align-items: center;
        outline: none;
        border: none;
        > img {
          &.desktop {
            width: 120px;
          }
        }
        > p {
          font-family: $casanova;
          font-size: 18px;
          color: var(--white);
          margin: 0;

          @media screen and (max-width: 767px) {
            display: none;
          }
        }
      }
    }
    > .open_navbar_btn {
      color: var(--yellow);
      font-size: 30px;
      display: none;
      @media screen and (max-width: 991px) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      > svg {
        cursor: pointer;
      }
      button.change_lang {
        background-color: transparent;
        color: #f2f2f2;
        cursor: pointer;
        border: 1px solid #f2f2f2;
        width: 30px;
        height: 30px;
        font-size: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        &:hover {
          background-color: #f2f2f2;
          color: #081336;
        }
      }
      .cart_btn {
        position: relative;
        cursor: pointer;
        margin-left: 0px;
        margin-right: 20px;
        line-height: 0.5;
        > p {
          position: absolute;
          color: var(--white);
          background-color: red;
          border-radius: 50%;
          top: -1px;
          right: 0px;
          text-align: center;
          width: 16px;
          line-height: 1.2;
          height: 16px;
          font-size: 14px;
          margin-bottom: 0px;
        }
      }
    }
    > .nav_links {
      display: flex;
      align-items: center;
      font-family: $monserrat;

      @media screen and (max-width: 991px) {
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        background-color: var(--white);
        width: 100%;
        height: 100vh;
        transform: translateX(100%);
        transition: 0.4s;
        padding-top: 50px;
        box-sizing: border-box;
        overflow-y: auto;
        background-color: var(--choco);
      }
      .cart_btn {
        position: relative;
        cursor: pointer;
        margin-right: 35px;
        color: var(--white);
        font-size: 30px;
        line-height: 0.5;
        > p {
          position: absolute;
          color: var(--white););
          background-color: red;
          border-radius: 50%;
          top: -1px;
          right: 0px;
          text-align: center;
          width: 16px;
          height: 16px;
          font-size: 14px;
          line-height: 1.1;
          margin-bottom: 0px;
        }
        @media (max-width: 991px) {
          display: none;
        }
      }

      > .close_menu_btn {
        position: absolute;
        top: 15px;
        right: 15px;
        color: var(--white);
        font-size: 20px;
        > svg {
          cursor: pointer;
        }
        @media screen and (min-width: 991px) {
          display: none;
        }
      }

      > .nav_link {
        margin-right: 35px;

        @media screen and (max-width: 992px) {
          margin-right: 25px;
        }

        @media screen and (max-width: 991px) {
          margin-right: 0;
        }
        &:last-child {
          margin-right: 0;
        }
        > a {
          font-family: $monserrat;
          color: var(--white););
          font-size: 18px;
          display: flex;
          align-items: center;
          padding-bottom: 5px;

          &.active {
            border-bottom: 3px solid var(--white););
          }
          &:hover {
            border-bottom: 3px solid var(--white););
          }

          @media screen and (max-width: 991px) {
            text-align: center;
            display: block;
            margin: 0 auto;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 150%;
            letter-spacing: 0.15px;
            padding: 15px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid transparent;
            border-image: linear-gradient(
              0.25turn,
              #96abe3,
              #96abe3,
              rgba(56, 2, 155, 0)
            );
            border-image-slice: 1;

            &.active {
              font-weight: 700;
              border-bottom: 1px solid transparent;
              border-image: linear-gradient(
                0.25turn,
                #96abe3,
                #96abe3,
                rgba(56, 2, 155, 0)
              );
              border-image-slice: 1;
            }
            &:hover {
              border-bottom: 1px solid transparent;
              border-image: linear-gradient(
                0.25turn,
                #96abe3,
                #96abe3,
                rgba(56, 2, 155, 0)
              );
              border-image-slice: 1;
              font-weight: 700;
            }
          }

          > .icon {
            margin-right: 5px;
            font-size: 22px;
          }
        }
        > button {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;

          > .icon {
            margin-right: 5px;
            font-size: 22px;
          }
        }

        > button.change_lang {
          background-color: transparent;
          color: var(--white););
          cursor: pointer;
          border: 1px solid var(--white););
          width: 30px;
          height: 30px;
          font-size: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3px;

          &:hover {
            background-color: var(--white););
            color: var(--yellow);
          }
          @media screen and (max-width: 991px) {;
            text-align: center;
            display: block;
            margin: 0 auto;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 150%;
            letter-spacing: 0.15px;
            padding: 15px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid transparent;
            border-image: linear-gradient(
              0.25turn,
              #96abe3,
              #96abe3,
              rgba(56, 2, 155, 0)
            );
            border-image-slice: 1;
            height: 75px !important;
            width: 100%;
            display: none;
          }
        }

        .headerSign_btns {
          display: flex;
          align-items: center;
          column-gap: 35px;
          padding: 0 15px;
          box-sizing: border-box;

          @media screen and (max-width: 991px) {
            flex-direction: column;
          }
        }

        button.sign_up_btn {
          font-family: $monserrat;
          border-radius: 5px;
          padding: 7px 15px;
          cursor: pointer;
          transition: 0.4s;
          font-size: 14px;

          &.signUp {
            background-color: var(--yellow);
            color: var(--choco);
            border: 1px solid var(--yellow);
            width: fit-content;
            padding-right:  15px;
            padding-left:  15px;
            &:hover {
              background-color: transparent;
              color: var(--yellow);
            }
            @media screen and (max-width: 991px) {
              width: 100%;
            }
          }
          &.signIn {
            background-color: transparent;
            color: var(--white);
            border: 1px solid var(--yellow);
            width: fit-content;
            padding-right:  15px;
            padding-left:  15px;
            &:hover {
              background-color: var(--yellow);
              color: var(--choco);
            }
            @media screen and (max-width: 991px) {
              width: 100%;
            }
          }
          @media screen and (max-width: 991px) {
            display: block;
            margin: 15px auto;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 150%;
            letter-spacing: 0.15px;
            // padding: 10px;
            width: 100%;
            max-width: 500px;
            text-transform: uppercase;
          }
        }

        button.dashboard_btn {
          display: flex;
          align-items: center;
          color: var(--white););
          > svg {
            margin-left: 5px;
          }

          &.profile_header_btn {
            border: none !important;
            padding: 0 !important;
            font-size: 18px !important;
            background-color: transparent;
            color:var(--choco);

            img {
              margin-right: 5px;
              width: 30px;
              height: 30px;
              border-radius: 100%;
              object-fit: contain;
              background: var(--yellow);
              border: var(--yellow);
            }

            &:hover {
              background-color: transparent !important;
              color: var(--choco) !important;
            }
          }
        }
      }

      .dropdown_nav {
        position: relative;

        @media screen and (max-width: 991px) {
          .auth_profile_dropdown {
            display: none;
          }
        }

        .nav_dropdown_links {
          background: linear-gradient(0deg, #f4b60b, #b6510c);
          position: absolute;
          top: 38px;
          right: 0;
          width: 150px;
          box-sizing: border-box;
          border-radius: 8px;
          z-index: 101;
          border: 1px solid var(--white););
          transition: 0.4s;
          overflow: hidden;
          display: none;

          &.show_nav_dropdown {
            display: unset;
          }

          > a {
            display: block;
            text-align: center;
            margin: 0 0;
            padding: 15px 0;
            color: var(--white););
            font-size: 18px;
            transition: 0.4s;
            border-bottom: 1px solid var(--white););

            &:hover {
              background-color: var(--white););
              color: var(--yellow);
            }
          }
          > button {
            display: block;
            width: 100%;
            padding: 15px;
            color: var(--white););
            background-color: transparent;
            font-size: 18px;
            border: none;
            outline: none;
            text-transform: capitalize;
            cursor: pointer;
            transition: 0.4s;

            &:hover {
              background-color: var(--white););
              color: var(--yellow);
            }
          }
        }
      }

      > .user_details_nav_link_mobile {
        padding: 15px;
        display: none;

        @media screen and (max-width: 991px) {
          display: unset;
        }

        > .userDetails {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          > .profileImg {
            > img {
              width: 72px;
              height: 72px;
              object-fit: cover;
              border-radius: 50%;
              background-color: var(--yellow);
            }
          }
          > .userName {
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0.16px;
            font-feature-settings: "pnum" on, "lnum" on;
            color: var(--white););
            margin-top: 15px;
          }
        }
        > .auth_user_links {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          margin-top: 15px;

          > a {
            font-size: 16px;
            color: #0a0a0a;
            border: 1px solid #ffff;
            background: #ffff;
            border-radius: 4px;
            padding: 8px 14px;
            width: fit-content;
            height: fit-content;
            cursor: pointer;
            transition: 0.4s;
            &:hover {
              background-color: transparent;
              color: #ffff;
            }
          }

          > button {
            font-size: 16px;
            color: #ffff;
            border: 1px solid #ffff;
            background: transparent;
            border-radius: 4px;
            padding: 8px 14px;
            width: fit-content;
            height: fit-content;
            cursor: pointer;
            transition: 0.4s;

            &:hover {
              background-color: #a9b5bb;
              color: #0a0a0a;
            }
          }
        }
      }

      > .sideNavdesktopImg {
        display: block;
        margin: 30px auto;
        width: 180px;

        @media screen and (min-width: 991px) {
          display: none;
        }
      }
    }

    > .open_navbar {
      transform: translateX(0);
      z-index: 100;
    }
  }
`;
